import type { useCurrentRefinements } from 'react-instantsearch-core';

type Items = ReturnType<typeof useCurrentRefinements>['items'];

export const getSelectedFiltersCount = (
  items: Items,
  query: string | string[],
  attribute: string,
) => {
  const isObjectIDMatch = (q: string) =>
    attribute === 'objectID' && /[A-Za-z0-9]{13}/.test(q.trim());

  if (Array.isArray(query)) {
    if (query.some(isObjectIDMatch)) {
      return 1;
    }
  } else if (isObjectIDMatch(query)) {
    return 1;
  }

  return items
    .find((item) => item.attribute.indexOf(attribute) !== -1)
    ?.refinements.filter((refinement) => refinement.value !== '').length;
};
